module.exports = {"330103001":"长庆街道","330103002":"武林街道","330103003":"天水街道","330103005":"潮鸣街道","330103006":"朝晖街道","330103007":"文晖街道","330103008":"东新街道","330103009":"石桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330103.json
// module id = 942
// module chunks = 0